import { hasYesOrNo } from 'models/validate';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import locationAddressModelValidator from 'forms/shared/validators/models/location/models/address';
import { setToStartOfMonth } from 'helpers/date';
import { SubstanceAlcoholRecievedCounselingItemModel } from '../types';

const substanceAlcoholReceivedCounselingItemValidator: ValidateJSModel<SubstanceAlcoholRecievedCounselingItemModel> = {
  TreatmentProviderName: { presence: true, hasValue: true },
  UseSameAddress: { presence: true, hasValue: { validator: hasYesOrNo } },
  TreatmentProviderAddress: {
    presence: true,
    location: { validator: locationAddressModelValidator },
  },
  AgencyAddress: (value, attributes) => {
    if (attributes?.UseSameAddress && attributes?.UseSameAddress.value === 'Yes') {
      return {};
    }
    return { presence: true, location: { validator: locationAddressModelValidator } };
  },
  AgencyName: { presence: true, hasValue: true },
  CounselingDates: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate), latest: DEFAULT_LATEST },
  }),
  CompletedTreatment: { presence: true, hasValue: { validator: hasYesOrNo } },
  NoCompletedTreatmentExplanation: { presence: true, hasValue: true },
  Comments: {},
};

export default substanceAlcoholReceivedCounselingItemValidator;
